import { common } from '../../classes/common';
import { viewerService } from '../../classes/viewer/viewerService';
import { contextBarViewerShared } from '../../contextBar/viewershared/contextBarViewerShared';
import { mainArea as viewerMainArea } from './mainArea';
import { thumbArea as viewerThumbArea } from './thumbArea';
import { workArea as viewerWorkArea } from './workArea';

export const viewer = {

  clear: function () {

    contextBarViewerShared.clear();
    viewerMainArea.clear();
  },

  show: function () {

    contextBarViewerShared.show();
    viewerMainArea.show();

  },

  open: function () {

    // CLEAR
    viewer.clear();

    // LOADING
    viewerMainArea.loading();

    // SHOW
    viewer.show();

    // CREATE AREAS
    const payload = {
      token: window.lsViewerToken
    };
    viewerService.getViewSummary(payload)
      .then((resultSummary) => {

        viewerService.getViewPermissions(payload)
          .then((resultPermissions) => {

            window.lsViewerConfig.docViewPermissions = resultPermissions;

            if (resultSummary.paginas === null || resultSummary.paginas.length < 1) {

                contextBarViewerShared.clear();
                viewerMainArea.clear();
                viewerWorkArea.viewerPage.showdocumentNoPages();
            }
            else {

                contextBarViewerShared.create(resultSummary.nome);
                viewerWorkArea.createContainers(resultSummary.page, resultSummary.total);
                viewerWorkArea.viewerPage.loading();
                viewerThumbArea.loading();
                viewerThumbArea.createThumbs(resultSummary);
            }

          }).catch((failDataPermissions) => {

            contextBarViewerShared.clear();
            viewerMainArea.clear();
            viewerWorkArea.viewerPage.showLoadPageError(common.getErrorMessage(failDataPermissions));

          });
          
      }).catch((failDataSummary) => {

        contextBarViewerShared.clear();
        viewerMainArea.clear();
        viewerWorkArea.viewerPage.showLoadPageError(common.getErrorMessage(failDataSummary));

      });

  },

  resize: function () {

    viewerThumbArea.resize();
    viewerWorkArea.resize();

  }


};
